export const stripTrailingSlash = (str) =>
  str.endsWith('/') ? str.slice(0, -1) : str;

export const getPrevNextPage = (baseUrl, currentIndex, totalPages) => {
  const basePath = process.env.URL
    ? process.env.URL
    : 'https://www.pandemicactionnetwork.org';
  const baseData = stripTrailingSlash(`${basePath?.replace(/\\/g, '')}`);
  const checkFirstIndex =
    currentIndex - 1 === 1
      ? `${baseData}${baseUrl}`
      : `${baseData}${baseUrl}${currentIndex - 1}/`;
  const prevPage = currentIndex - 1 !== 0 ? checkFirstIndex : null;

  const nextPage =
    currentIndex + 1 > totalPages
      ? null
      : `${baseData}${baseUrl}${currentIndex + 1}/`;
  return {
    prevPage,
    nextPage,
  };
};

export const isBrowser = () => {
  return typeof window !== 'undefined';
};

export const validURL = (str) => {
  const regex =
    /(?:https?):\/\/(\w+:?\w*)?(\S+)(:\d+)?(\/|\/([\w#!:.?+=&%!\-\/]))?/;
  return regex.test(str);
};

export const getSlug = (url) => {
  if (validURL(url)) {
    const temp = new URL(url);
    return temp.pathname;
  }
  return url;
};

/**
 *
 * @param id - The #id present in the url for smooth scrolling of section.
 * @return - scrolls to the specified sections with specified offset added due to sticky header
 */
export const handleTagClick = (id) => {
  if (id === '#') {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  } else if (id && id !== undefined) {
    const element = document.querySelector(id);
    const headerOffset = 100;
    const elementPosition = element.getBoundingClientRect().top;
    const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth',
    });
    window.history.replaceState(null, '', id);
  }
};

export const extractSlugFromURL = (url) => {
  // Define a regular expression to match the slug part.
  const slugRegex = /\/([^/]+)\//;

  // Use the regex to find the slug part in the URL.
  const match = url?.match(slugRegex);

  if (match && match[1]) {
    // match[1] contains the extracted slug.
    return match[1];
  }
};
